import * as React from 'react';
import {Helmet} from 'react-helmet';

import {Link} from 'react-router-dom';

import {List} from '@common/typescript/objects/List';

import '@app/scss/components/resourcesPage.scss';
import {ResourceTopic} from '@app/objects/ResourceTopic';
import {rest} from '@app/components/Api';
const cat = require('@app/content/qualityOfLife/cat.svg');
const dog = require('@app/images/link-icons/dog.svg');
const symptom = require('@app/images/link-icons/vet.svg');

interface ResourceTopicWithImg extends ResourceTopic {
	src?: string;
}
const ResourcesPage = () => {
	const [topics, setTopics] = React.useState<ResourceTopicWithImg[]>([]);
	const topicImages = {
		'common-diseases-in-cats': cat,
		'common-diseases-in-dogs': dog,
		'symptom-management': symptom
	};

	React.useEffect(() => {
		rest.get<List<ResourceTopic>>('v1/resourceTopics')
			.then((res) => {
				setTopics(res.list);
			});
	}, []);

	return (
		<>
			<Helmet>
				<title>Family Resource Center | Lap of Love</title>
			</Helmet>
			<div className="resources-page">
				<h3>View our resources to learn more about caring for your geriatric or terminally ill pet</h3>
				<div className="resources-page__block">
					{
						topics.length && topics.map((item) => {
							return(
								<Link to={`/resource-center/${item.url}`} key={item.id} className="resources-page__card">
									<img
										style={{width: 100, height: 100}}
										src={topicImages[item.url]}
									 alt=""/>
									<h5>{item.title}</h5>
								</Link>
							);
						})
					}
				</div>
			</div>
		</>
	);
};

export default ResourcesPage;